import { h, ComponentChildren, ComponentChild } from "preact";
import "./button.scss";
import { useEffect } from "preact/hooks";

// https://mui.com/material-ui/react-button/

const autofocus = (n: HTMLButtonElement | null) => n?.focus();

type Props = {
    children: ComponentChildren
    id?: string;
    disabled?: boolean;
    elevated?: boolean;
    variant?: "default" | "text" | "contained" | "outline";
    size?: "default" | "tiny" | "small" | "medium" | "large";
    class?: string;
    color?: string;
    startIcon?: ComponentChild;
    endIcon?: ComponentChild;
};

type ButtonProps = Props & {
    onClick?: () => void;
    autofocus?: boolean;
};

export const Button = (props: ButtonProps) => {
    const css_variant = (!props.variant || props.variant === "default") ? " contained" : (" " + props.variant);
    const css_size = (!props.size || props.size === "default") ? " medium" : (" " + props.size);
    const css_elevated = props.elevated && (!props.variant || props.variant === "contained") ? " elevated" : "";
    const css_class = props.class ? (" " + props.class) : "";
    return (
        <button
            id={props.id}
            class={"material-button" + css_variant + css_size + css_elevated + css_class}
            style={props.color ? { "--button-color": props.color } : undefined}
            autofocus={props.autofocus}
            ref={props.autofocus ? autofocus : null}
            disabled={props.disabled}
            onClick={props.onClick}>
            {
                props.startIcon
            }
            {props.children}
            {
                props.endIcon
            }
        </button>
    );
}

type LinkButtonProps = Props & {
    href: string;
    target?: string;
};

export const LinkButton = (props: LinkButtonProps) => {
    const css_variant = (!props.variant || props.variant === "default") ? " contained" : (" " + props.variant);
    const css_size = (!props.size || props.size === "default") ? " medium" : (" " + props.size);
    const css_elevated = props.elevated && (!props.variant || props.variant === "contained") ? " elevated" : "";
    const css_class = props.class ? (" " + props.class) : "";
    return (
        <a
            id={props.id}
            class={"material-button" + css_variant + css_size + css_elevated + css_class}
            style={props.color ? { "--button-color": props.color } : undefined}
            disabled={props.disabled}
            href={props.href}
            target={props.target}>
            {
                props.startIcon
            }
            {props.children}
            {
                props.endIcon
            }
        </a>
    );
}

